export const isMobile = (value) => (value < 769 ? true : false);
